import { render, staticRenderFns } from "./CatalogCheckboxPicker.vue?vue&type=template&id=31bf826f&scoped=true"
import script from "./CatalogCheckboxPicker.vue?vue&type=script&lang=js"
export * from "./CatalogCheckboxPicker.vue?vue&type=script&lang=js"
import style0 from "./CatalogCheckboxPicker.vue?vue&type=style&index=0&id=31bf826f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf826f",
  null
  
)

export default component.exports